import type { IStorage } from "@interfaces";
import { BillingInfo } from "@src/domain/billingInfo";
import { ItemStorageFactory } from "./itemStorage";

export const billingInfo = ({ storage }: { storage: IStorage }) =>
	ItemStorageFactory<BillingInfo>(storage, "bi_v2");
